import { AlertTriangle, X } from 'lucide-react';

/**
 * Compact warning/error alert. Errors stay fully visible — never hidden.
 * items: array of strings (one line per loading failure).
 */
export default function Alert({ title = 'Alguns dados não carregaram', items = [], onDismiss }) {
  if (!items || items.length === 0) return null;

  return (
    <div
      role="alert"
      className="flex items-start gap-2.5 rounded-lg border border-warning/25 bg-warning/[0.06] px-3 py-2.5"
    >
      <AlertTriangle size={15} className="mt-0.5 shrink-0 text-warning" />
      <div className="min-w-0 flex-1">
        <p className="text-xs font-semibold text-warning">{title}</p>
        {items.length === 1 ? (
          <p className="mt-0.5 break-words text-xs leading-relaxed text-zinc-400">{items[0]}</p>
        ) : (
          <ul className="mt-1 space-y-0.5 text-xs leading-relaxed text-zinc-400">
            {items.map((item) => (
              <li key={item} className="break-words">· {item}</li>
            ))}
          </ul>
        )}
      </div>
      {onDismiss && (
        <button
          type="button"
          onClick={onDismiss}
          aria-label="Dispensar aviso"
          className="shrink-0 rounded-md p-1 text-zinc-500 transition duration-150 hover:bg-white/5 hover:text-zinc-300"
        >
          <X size={13} />
        </button>
      )}
    </div>
  );
}
